import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8BillRowsByMonth } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
  year: number;
};

export const getBillRows = async (
  params: Params
): Promise<M8BillRowsByMonth> => {
  const response = await customFetch(
    getM8AdminURL(`getBillRows?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
